import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useCallback, useContext, useMemo } from 'react';
import GlobalContext from '~/context/vdp/GlobalContext';
import SpinnerContext from '~/context/vdp/SpinnerContext';
import { useIsNewVehicle } from '~/context/vdp/VehicleContext';
import useForceError from './useForceError';

export default function useSpinnerConfig() {
  const { trackEvent } = useContext(AnalyticsContext);
  const {
    setOpenHotspot,
    setOpenImmersive,
    setOpenSpinner,
    setIsInTourMode,
    setIsSpinnerImmersive,
    spinnerReady: { setData: setSpinnerReady }
  } = useContext(SpinnerContext);
  const { experimentsLoaded } = useContext(GlobalContext);
  const forceError = useForceError();
  const isNewVehicle = useIsNewVehicle();

  const getHelpers = useCallback(
    ({
      openImmersive = () => {},
      openSpinner = () => {},
      openHotspot = () => {}
    }) => {
      setOpenHotspot(() => openHotspot);
      setOpenImmersive(() => openImmersive);
      setOpenSpinner(() => openSpinner);
    },
    [setOpenHotspot, setOpenImmersive, setOpenSpinner]
  );

  return useMemo(
    () => ({
      autoResize: true,
      autoResizing: true,
      callbacks: { trackEvent },
      didLoadExperiments: experimentsLoaded,
      eventListener: (event: { type: string; payload?: any }) => {
        if (forceError) forceError();

        switch (event.type) {
          case 'ui/setSpinnerReady':
          case 'spinner/ui/SET_SPINNER_READY':
            setSpinnerReady(true);
            break;
          case 'ui/setImmersiveMode':
          case 'spinner/ui/SET_IMMERSIVE_MODE':
            setIsSpinnerImmersive(event.payload);
            break;
          case 'spinner/ui/SET_TOUR_FOCUS':
            setIsInTourMode(Boolean(event.payload));
            break;
          default:
        }
      },
      getHelpers,
      isNewVehicle
    }),
    [
      experimentsLoaded,
      forceError,
      getHelpers,
      isNewVehicle,
      setIsInTourMode,
      setIsSpinnerImmersive,
      setSpinnerReady,
      trackEvent
    ]
  );
}
